import { createContext, useContext, useEffect, useState } from "react";

const FavCtx = createContext(null);
export const useFavorites = () => useContext(FavCtx);

export function FavoritesProvider({ children }) {
  const [favorites, setFavorites] = useState(() => {
    try { return JSON.parse(localStorage.getItem("bmm_favorites") || "[]"); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("bmm_favorites", JSON.stringify(favorites));
  }, [favorites]);

  const toggle = (id) =>
    setFavorites((f) => (f.includes(id) ? f.filter((x) => x !== id) : [...f, id]));
  const isFav = (id) => favorites.includes(id);

  return (
    <FavCtx.Provider value={{ favorites, toggle, isFav }}>{children}</FavCtx.Provider>
  );
}
